export default __webpack_public_path__ + "static/media/hero-bcg-2.875f4c00.jpg";